/** `/channels/$channelId` search params: active layer tab, selected scope, preview target. */
export interface ChannelEditorSearch {
  tab?: 'base' | 'location' | 'group' | 'display'
  scope?: string
  /** Display id to preview for; absent = organization base. */
  preview?: string
}

const TABS = new Set(['base', 'location', 'group', 'display'])
const str = (v: unknown): string | undefined => (typeof v === 'string' && v.length > 0 ? v : undefined)

export function validateChannelEditorSearch(s: Record<string, unknown>): ChannelEditorSearch {
  const tab = typeof s.tab === 'string' && TABS.has(s.tab) ? (s.tab as ChannelEditorSearch['tab']) : undefined
  return { tab: tab === 'base' ? undefined : tab, scope: tab && tab !== 'base' ? str(s.scope) : undefined, preview: str(s.preview) }
}
